import { Outlet } from "react-router-dom";

export default function ProjsProtocol(){
  return(
    <div>
      <Outlet />
    </div>
  );
}